/**
 * L'adresse de la politique de confidentialité publique de l'atelier Fixer
 * Lite (FIXERLIGHT-095), que l'étape 3 du tunnel annuaire cite. Pur, sans
 * React.
 *
 * Une seule adresse, staging compris : la recette de l'atelier est derrière
 * l'authentification Vercel, un visiteur n'y lirait rien. Le texte est le même
 * partout.
 */

// L'adresse de production de l'atelier (décision de Fred, 07/10), la même que
// `FIXER_LITE_APP_URL` côté api.
export const ATELIER_PRODUCTION = 'https://pro.roulezjeunesse.com';
export const CHEMIN_CONFIDENTIALITE = '/legal/confidentialite';

export function lienConfidentialiteAtelier() {
  return `${ATELIER_PRODUCTION}${CHEMIN_CONFIDENTIALITE}`;
}
